export const experience = [
  {
    position: "Senior Software Engineer",
    company: "Y Tree",
    companyLink: "https://www.y-tree.com/",
    location: "London, UK (Hybrid)",
    dates: {
      real: { startDate: "2024-08", endDate: "2026-06" }, // 27-08-2024 – 08-06-2026
      linkedin: { startDate: "2024-08", endDate: "2026-06" },
      nooverlap: { startDate: "2024-08", endDate: "2026-06" },
    },
    companyLogo: "YTreeLogo",
    skills: [
      "TypeScript",
      "Python",
      "React",
      "Anthropic Claude",
      "Agentic Workflows",
      "LLM/MCP/RAG",
      "Cypress/Playwright",
    ],
    bullets: [
      "**Led development** of the \"Wealth Overview\" — an interactive dashboard for financial portfolios insights, including value tracking, performance metrics, exposure breakdowns, and historical trends with configurable timeframes; increasing **user engagement by 30%** and reducing data clarity related requests to advice team.",
      "Delivered end-to-end digital client onboarding covering: a) automated identity verification; b) personal, financial, and tax questionnaires; c) dynamic T&Cs acceptance based on service tier; **reducing onboarding time from 30+ days** to **under 7** and significantly cutting onboarding team workload.",
      "Developed a document management portal enabling clients to view, download, and navigate financial documents, advice reports, and fee schedules — **replacing manual email exchange** with a centralised solution integrated with the back-office.",
      "Delivered **Yoda**, an **LLM-powered RAG assistant** for financial advisers, retrieving internal documentation and high-quality historical advice from Confluence, and client data via APIs to support advisers in answering client queries, **improving the consistency of client advice.**"
    ],
  },
  {
    position: "Engineering Lead",
    company: "Apiari",
    companyLink: "https://www.linkedin.com/company/theapiari/",
    location: "London, UK (Remote)",
    dates: {
      real: { startDate: "2023-02", endDate: "2026-05" }, // 01-05-2026
      linkedin: { startDate: "2023-02", endDate: "2025-01" },
      nooverlap: { startDate: "2023-02", endDate: "2024-08" },
    },
    companyLogo: "ApiariLogo",
    skills: [
      "Node.js",
      "TypeScript",
      "AWS",
      "React",
      "DynamoDB",
      "Next.js",
      "GraphQL",
    ],
    bullets: [
      "Designed and built a **customer geo-matching algorithm** using the Google Maps API, enabling the product to **scale** from a **New York City-only** solution to a **nationwide** platform.",
      "Led **multiple third-party integrations**, including Twilio, Stripe, Google Maps, Slack, and Checkr, **enabling** payment processing, communication workflows, geo-location services, background verification, and internal operational **automation across the platform.**",
      "Planned and managed runtime and **infrastructure maintenance** and **modernisation** across AWS-based services, driving long-term tech debt reduction, CI/CD pipeline improvements, dependency and runtime upgrades, and overall platform reliability, security, and maintainability.",
      "Architected and supervised implementation of **internal AI solutions** leveraging **LLMs** and **agentic workflows**, enabling development automation, and productivity improvements across the entire team.",
      // "Developed customer-facing products and services as well as a care-providers matching platform using TypeScript, React, Node, Serverless Framework and AWS.",
      //"Integrated external services and APIs to improve internal operations and scalability, including but not limited to Stripe, Twilio, Chat-GPT API.",
      // "Created and implemented a technical strategy to iteratively migrate away from a legacy front-end tech stack.",
    ],
  },
  {
    position: "Senior Full-stack Engineer",
    company: "Ciklum",
    companyLink: "https://www.linkedin.com/company/ciklum/",
    location: "Lviv, Ukraine (Remote)",
    // from the 22d of March 2021 until the 8th of November 2023 in the capacity of Senior JavaScript Developer;
    // from the 9th of November 2023 until present time in the capacity of Senior JavaScript Software Engineer.
    dates: {
      real: { startDate: "2021-03", endDate: "2024-07" }, // 22-03-2021 -> 09-11-2023 -> 17-07-2026
      linkedin: { startDate: "2021-03", endDate: "2024-07" }, // 22-03-2021 -> 09-11-2023 -> 17-07-2026
      nooverlap: { startDate: "2021-03", endDate: "2023-02" },
    },
    companyLogo: "CiklumLogo",
    skills: [
      "TypeScript",
      "Node.js",
      "React",
      "PostgreSQL",
      "Kafka",
      "GraphQL",
      "Nest.js",
    ],
    bullets: [
      // "Managed the entire software development life cycle, which consisted of gathering requirements, development planning, solution design, data and software engineering using tools like Node.js and microservice architecture.",
      "Developed and executed multiple microservices (Authentication, Permission, Disclosure etc.) for enterprise-level SaaS **FinTech** SymphonyAI utilising Node.js, TypeScript, PostgreSQL, Kafka and Nest.js.",
      "Designed and delivered configuration-driven application for creation, processing and sending AML Disclosures across major economic regions.",
      // "Ensured a high level of fulfilling financial industry compliance with a focus on Data Security, Audit and Accountability.",
    ],
  },
  {
    position: "Full Stack Engineer",
    company: "Lohika",
    companyLink: "https://www.linkedin.com/company/lohika/",
    location: "Lviv, Ukraine (Hybrid)",
    dates: {
      real: { startDate: "2019-02", endDate: "2021-03" },
      linkedin: { startDate: "2019-02", endDate: "2021-03" },
      nooverlap: { startDate: "2019-02", endDate: "2021-03" },
    },
    companyLogo: "LohikaLogo",
    skills: ["React", "TypeScript", "Redux", "Formik", "Ant Design", "Git"],
    bullets: [
      "Build internal-use fleet and airport management system for Air Arabia.",
      "Ensured a high level of performance for multi-tier dynamic user forms and components optimising every aspect of data calculation and rendering.",
      // "Designed a cross-project UI-components library which was reused by multiple teams to facilitate and accelerate project timelines.",
      // "Ensured a high level of automated testing using Jest, React Testing Library, and Cypress."",
    ],
  },
  {
    position: "Middle Full Stack Engineer",
    company: "ProductCrafters",
    companyLink: "https://www.linkedin.com/company/product-crafters/",
    location: "Khmelnytsky, Ukraine (On-site)",
    dates: {
      real: { startDate: "2017-12", endDate: "2019-02" },
      linkedin: { startDate: "2017-12", endDate: "2019-02" },
      nooverlap: { startDate: "2017-12", endDate: "2019-02" },
    },
    companyLogo: "ProductCraftersLogo",
    skills: ["JavaScript", "Node.js", "Redis", "PostgreSQL", "MongoDB", "Jest"],
    bullets: [
      // "Engaged in full stack development across multiple agency client projects. This encompassed both backend and frontend aspects, ensuring seamless functionality and appealing user interfaces.",
      // "Implemented multiple comprehensive frontend UIs with a strong focus on usability, accessibility, and user experience quality.",
      // 'Ensured high code quality and sustainability, designed and developed multi-level testing for the product.',
      // 'Oversaw product deployment, support and maintenance.',
    ],
  },
  // {
  //   position: "Front-end engineer",
  //   company: "Circle",
  //   companyLink: null,
  //   startDate: "2016-01",
  //   endDate: "2017-12",
  //   companyLogo: "CircleLogo",
  //   skills: ["HTML/CSS", "JavaScript", "React", "Bootstrap", "PHP", "MySQL"],
  //   bullets: [],
  // },
];

export const summary =
`
  Software engineer with 9+ years of experience. Skilled in developing pragmatic,
  well-tested, and maintainable solutions with a strong focus on user experience, code quality, and business value.
  Particularly interested in **FinTech**, Python, **Data Science, AI**, and **Machine Learning.**
`;